var portfolioList = {
	label: {
		caption: "Liste de Portefeuilles",
		name: "Portefeuille",
		currency: "Devise",
		numberOfPositions: "Positions",
		numberOfTransactions: "Transactions",
		actions: "Actions"
	},
	noPortfolios: {
		title: "Info",
		message: "Aucun portefeuille n'a encore été créé. Veuillez cliquer sur le \"Ajouter portefeuille\" bouton et remplissez le formulaire pour créer un portefeuille."
	},
	error: {
		title: "Une erreur s'est produite.",
		portfolioLimitExceeded: "Limite de portefeuille dépassée."
	},
	createPortfolioAction: "Ajouter portefeuille",
	editPortfolioAction: "Modifier portefeuille",
	deletePortfolioAction: "Supprimer portefeuille",
	showActions: "Afficher les actions"
};
var fr = {
	portfolioList: portfolioList
};

export { fr as default, portfolioList };
